export default "__VITE_ASSET__3j987v42__"